import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import OneStaff from "./OneStaff";
import { FaGraduationCap, FaBriefcase, FaAward, FaArrowRight, FaArrowDown } from "react-icons/fa6";
import marcelino from "../assets/marcelino.png";
import newton from "../assets/newton.png";
import { IoMdArrowDropdown } from "react-icons/io";

export default function StaffBanner() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    await appContext.getAllStaff();
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  const partners = [
    {
      name: "CPA Marcelino Kilyenyi",
      title: "PARTNER",
      image: marcelino,
      credentials: "CFIP, ACPA-PP, B.Com",
      points: [
        "CFIP, ACPA-PP, B.Com",
        "15+ Years of Experience",
      ],
      subItem: "marcelino"
    },
    {
      name: "CPA Newton Mathew",
      title: "PARTNER",
      image: newton,
      credentials: "ACPA-PP, B.Com",
      points: [
        "ACPA-PP, B.Com",
        "15+ Years of Experience",
      ],
      subItem: "newton"
    }
  ];

  if (!ready) {
    return (
      <div className="container py-5 d-flex justify-content-center">
        {getInlineLoader()}
      </div>
    );
  }

  const keyStaff = Array.isArray(appContext.allStaff) ? appContext.allStaff : [];

  return (
    <section className="atric-staff-section py-5 bg-white">
      <div className="container py-4">
        
        {/* --- SECTION 1: MANAGING PARTNERS --- */}
        <div className="text-center mb-5">
          <h2 className="mb-2 text-primary font-bold">OUR TEAM</h2>
          <h1 className="font-semi-bold text-dark">Partners</h1>
          <div className="h-line mx-auto" />
        </div>

        <div className="row g-4 justify-content-center mb-5 pb-5">
          {partners.map((partner, i) => (
            <div key={i} className="col-lg-5">
              <div className="partner-card h-100 p-4 rounded-4 border shadow-sm">
                <div className="d-flex flex-column  gap-4 mb-4">
                  <div className="partner-avatar-wrap">
                    <img src={partner.image} alt={partner.name} className="partner-img" />
                  </div>
                  <div>
                    <h4 className="fw-bold mb-1">{partner.name}</h4>
                    <p className="text-primary fw-bold small mb-0 text-uppercase tracking-wider">{partner.title}</p>
                    <div className="credentials-tag mt-2">
                       <FaGraduationCap className="me-2" /> {partner.credentials}
                    </div>
                  </div>
                </div>
                
                <div className="partner-details">
                  <ul className="list-unstyled mb-4">
                    {partner.points.map((pt, idx) => (
                      <li key={idx} className="">
                        <span>{pt}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <button 
                  onClick={() => appContext.navTo({ item: 'view', subItem: partner.subItem })}
                  className="btn btn-primary btn-sm w-100 fw-bold d-flex align-items-center justify-content-center py-2"
                >
                  View Full Profile <IoMdArrowDropdown className="ms-2" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* --- SECTION 2: KEY STAFF (DYNAMIC) --- */}
        <div className="text-center mb-5 mt-5">
          <h2 className="display-6 fw-bold text-dark">Key Staff</h2>
          <p className="text-muted small">Specialized staff supporting our global practice areas</p>
        </div>

        <div className="row g-4 justify-content-center">
          {keyStaff.length > 0 ? (
            keyStaff.map((item, i) => (
              <div key={i} className="col-12 col-md-6 col-lg-4">
                <div className="staff-dynamic-wrap h-100">
                   <OneStaff data={item} />
                </div>
              </div>
            ))
          ) : (
            <div className="col-12">
              <div className="text-center py-5 bg-light rounded-4 border-dashed">
                <p className="text-muted mb-0 italic">No additional personnel records found.</p>
              </div>
            </div>
          )}
        </div>
      </div>

      <style>{`
        .atric-staff-section {
          background-image: radial-gradient(#e2e8f0 0.5px, transparent 0.5px);
          background-size: 30px 30px;
        }

        .atric-badge {
          display: inline-block;
          background: #e0f2fe;
          color: #0369a1;
          padding: 5px 15px;
          border-radius: 50px;
          font-size: 0.7rem;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 2px;
        }

        .h-line {
          width: 50px;
          height: 3px;
          background: #0284c7;
          border-radius: 10px;
          margin-top: 10px;
        }

        .partner-card {
          background: #ffffff;
          transition: all 0.3s ease;
          border-color: #f1f5f9;
        }

        .partner-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(0,0,0,0.08) !important;
          border-color: #0284c7;
        }

        .partner-avatar-wrap {
          width: 100%;
          height: auto;
          border-radius: 15px;
          overflow: hidden;
          border: 3px solid #f8fafc;
          flex-shrink: 0;
        }

        .partner-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .credentials-tag {
          font-size: 0.75rem;
          color: #64748b;
          font-weight: 600;
          background: #f1f5f9;
          padding: 4px 10px;
          border-radius: 4px;
          display: none;
          align-items: center;
        }

        .dot-indicator {
          width: 6px;
          height: 6px;
          background: #0284c7;
          border-radius: 50%;
          flex-shrink: 0;
        }

        .border-dashed {
          border: 2px dashed #e2e8f0;
        }

        .staff-dynamic-wrap {
          transition: transform 0.3s ease;
        }
        
        .staff-dynamic-wrap:hover {
          transform: scale(1.02);
        }

        @media (max-width: 768px) {
          .partner-card { text-align: center; }
          .partner-card .d-flex { flex-direction: column; }
          .partner-avatar-wrap { margin-bottom: 15px; }
        }
      `}</style>
    </section>
  );
}